// For Declarations
import React from 'react';
import { YesNoInput } from '@fmm/react-encompass-inputs';
import { FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useAutosavingFormContext } from 'src/components/ConnectedInputs/AutosavingForm';
import styles from './index.module.scss';
import clsx from 'clsx';

export const ConnectedYesNoEmptyInputGroup = React.forwardRef(
  (
    {
      name,
      rules,
      required,
      label,
      options = [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
      id,
      ...props
    },
    ref,
  ) => {
    const { id: contextId } = useAutosavingFormContext();
    return (
      <Controller
        name={name}
        rules={{
          required,
          ...rules,
        }}
        render={({ field: { value, onChange } }) => {
          // YesNoInput is designed for "Y"/"N" strings.
          // Convert boolean ↔ string at this boundary.
          const toStr = (v) => {
            if (v === true) return 'Y';
            if (v === false) return 'N';
            return '';
          };
          const toBool = (v) => {
            if (v === 'Y') return true;
            if (v === 'N') return false;
            return null;
          };
          const strOptions = options.map((o) => ({
            ...o,
            value: toStr(o.value),
          }));
          return (
            <FormControlLabel
              id={(id ?? contextId) ? `${contextId}.${name}` : name}
              control={(
                <YesNoInput
                  className={clsx(styles.yesNoEmptyGroup)}
                  value={toStr(value)}
                  onChange={(e) => {
                    onChange(toBool(e.target.value));
                  }}
                  options={strOptions}
                />
              )}
              label={label}
              disabled={props.disabled}
              ref={ref}
            />
          );
        }}
      />
    );
  },
);
ConnectedYesNoEmptyInputGroup.defaultProps = {};
ConnectedYesNoEmptyInputGroup.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  id: PropTypes.string,
};
